<template>
  <div v-if="user && $store.state.users && $store.state.users[user]">
    <router-link :class="(displaytype === 'column' ? 'column ' : ' ') + imageOnly ? 'center' : ''" class="flex align-center" :to="nolink ? '' : '/profile/' + user">
      <img v-if="!nameOnly && (userImage || $store.state.app.basics.logo)" :style="`width: ${displaysize || 16}px; height: ${displaysize || 16}px; object-fit: cover; border-radius: 100%;`" :src="userImage || $store.state.app.basics.logo" :alt="($store.state.ref.name[user] || 'Anonymous') + ' profile image'">
      <span class="l4" v-if="!imageOnly || !userImage">{{$store.state.ref.name[user] || 'Anonymous'}}</span>
    </router-link>
  </div>
  <div v-else>No user loaded</div>
</template>
<script>
export default {
  computed: {
     userImage () {
       // console.log((this.$store.state.users && this.$store.state.users[this.user]) || this.$store.state.app.basics.logo);
       return (this.$store.state.ref.image[this.user] || this.$store.state.defaults.userimage)
     },
     user () {
       // console.log(this.userid, this.$store.state.auth.uid, this.$store.state.users);
       return this.userid || this.$store.state.auth.uid
     }
  },
  name: 'user',
  props: {'userid': {type: String}, 'displaysize': {type: String}, 'imageOnly': {type: String}, 'nameOnly': {type: String}, 'nolink': {type: String}, 'displaytype': {type: String}}
}
</script>